module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limite-adicional-proposal/component/actions/send-la-to-ctc/send-la-to-ctc.component.scss
// module id = ./src/app/limite-adicional-proposal/component/actions/send-la-to-ctc/send-la-to-ctc.component.scss
// module chunks = main